<div class="dam-item-version-list">
  <div class="dam-item-version-item" *ngFor="let item of damItemVersions">
    <div class="row">
      <div class="col-2 dam-item-version-item-preview">
        <app-secured-image [src]="damService.getImagePath(item, true)"/>
      </div>
      <div class="col-10">
        <div class="dam-item-version-item-header">
          <div class="row">
            <div class="col-12">
              <a (click)="download(item.id, item.header)" target="_blank">{{ item.header }}</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ item?.mimeType }}</div>
          <div class="col-3">{{ item?.size | formatSize }}</div>
          <div class="col-3">{{ item?.createdAt | date: 'dd.MM.yyyy HH:mm' }}</div>
          <div class="col-3"><a (click)="show(actions, item.id)">Смотреть</a><br></div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actions let-content="content">
  <a download size="small" nbButton [href]="content" i18n="@@Download"> Скачать </a>
</ng-template>
